import { makeAutoObservable } from 'mobx';

class OrderStore {
	orderId: string | null = null;

	constructor() {
		makeAutoObservable(this);
	}

	setOrderId = (state: string | null) => {
		this.orderId = state;
	};
}

const orderStore = new OrderStore();
export default orderStore;
